<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Seguimiento</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div class="col-md-12 col-md-offset-2">
          <div v-if="isDataLoaded" id="wizardCard" class="card card-wizard">
            <form-wizard
              ref="wizard"
              :start-index="currentStage"
              color="#66615B"
              error-color="#EB5E28"
              shape="tab"
              subtitle=""
              title=""
              @on-complete="wizardComplete"
              @on-change="onChangeStep"
            >
              <tab-content icon="fas fa-bell" title="Pre Emergencia">
                <pre-emergence-data v-if="showPreEmergenceData" :plot="plot" @edit="editPreEmergence = true" />

                <pre-emergence-form v-else ref="preEmergenceForm" :plot="plot" @saved="updatePreEmergence" />
              </tab-content>

              <tab-content icon="fas fa-exclamation-triangle" title="Emergencia">
                <emergence-data v-if="showEmergenceData" :plot="plot" @edit="editEmergence = true" />

                <emergence-form v-else ref="emergenceForm" :plot="plot" @saved="updateEmergence" />
              </tab-content>

              <tab-content icon="fas fa-industry" title="Producción">
                <harvest-data v-if="showHarvestData" :plot="plot" @edit="editHarvest = true" />

                <harvest-form v-else ref="harvestForm" :plot="plot" @saved="updateHarvest" />
              </tab-content>

              <tab-content icon="fas fa-check" title="Resumen">
                <trace-resume v-if="hasPreEmergence && hasEmergence && hasHarvest" :plot="plot"> </trace-resume>
              </tab-content>

              <template slot="prev" scope="{ isLastStep }">
                <button
                  v-show="!isLastStep && showingData"
                  slot="prev"
                  class="btn btn-default btn-fill btn-wd btn-back"
                >
                  Anterior
                </button>
              </template>

              <button v-show="showingData" slot="next" class="btn btn-default btn-fill btn-wd btn-next" @click="key++">
                Siguiente
              </button>
              <button slot="finish" class="btn btn-default btn-fill btn-wd">Ir al lote</button>
            </form-wizard>
          </div>
        </div>
      </div>

      <observations
        v-if="isDataLoaded && showingData && $can('index', 'plot_stage_comments')"
        :key="key"
        :title="'Observaciones para ' + currentResource.title"
        :commentable="currentResource"
        :commentable-type="currentResource.name"
        :comments="comments"
      >
      </observations>

      <card v-if="pictures" :key="key + 1">
        <plot-images-list
          ref="imageList"
          :can-delete="true"
          :can-edit="true"
          :pictures="pictures"
          @update-picture="updatePicture"
          @remove-picture="removePicture"
        />
      </card>

      <plot-images-form v-if="isDataLoaded && showingData" :resource="currentResource" @fetchPictures="fetchPictures">
      </plot-images-form>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import PreEmergenceForm from '@/views/Plots/Forms/PreEmergenceForm';
import EmergenceForm from '@/views/Plots/Forms/EmergenceForm';
import HarvestForm from '@/views/Plots/Forms/HarvestForm';
import PreEmergenceData from '@/views/Plots/Show/PreEmergenceData';
import EmergenceData from '@/views/Plots/Show/EmergenceData';
import HarvestData from '@/views/Plots/Show/HarvestData';
import TraceResume from '@/views/Plots/Widgets/TraceResume';
import PlotImagesList from '@/views/Plots/List/PlotImagesList';
import PlotImagesForm from '@/views/Plots/Forms/PlotImagesForm';
import Observations from './Show/Observations';

export default {
  components: {
    RouteBreadCrumb,
    FormWizard,
    TabContent,
    PreEmergenceForm,
    PreEmergenceData,
    EmergenceData,
    EmergenceForm,
    HarvestData,
    HarvestForm,
    PlotImagesForm,
    PlotImagesList,
    TraceResume,
    Observations,
  },

  data() {
    return {
      key: 0,
      isDataLoaded: false,
      validated: false,
      activeStep: 0,
      wizardModel: {},
      plotId: null,
      plot: {},
      editPreEmergence: false,
      editEmergence: false,
      editHarvest: false,
      stageResources: [
        {
          name: 'pre_emergences',
          title: 'Pre-Emergencia',
          prop: 'preEmergence',
        },
        {
          name: 'emergences',
          title: 'Emergencia',
          prop: 'emergence',
        },
        {
          name: 'harvests',
          title: 'Producción',
          prop: 'harvest',
        },
      ],
    };
  },

  computed: {
    currentStage() {
      if (this.$route.query.hasOwnProperty('stage')) {
        let stage = +this.$route.query.stage || 0;

        if (stage < 0 || stage > 3) {
          return 0;
        }

        return stage;
      }
      return 0;
    },

    currentResource() {
      const res = this.stageResources[this.activeStep];
      return { ...res, ...this.plot[res.prop] };
    },

    pictures() {
      // if (this.plot.preEmergence && this.showPreEmergenceData) {
      //   if (this.plot.preEmergence.pictures && this.plot.preEmergence.pictures.length > 0) {
      //     return this.plot.preEmergence.pictures
      //   }
      // }
      //
      // if (this.plot.emergence && this.showEmergenceData) {
      //   if (this.plot.emergence.pictures && this.plot.emergence.pictures.length > 0) {
      //     return this.plot.emergence.pictures
      //   }
      // }
      //
      // if (this.plot.harvest && this.showHarvestData) {
      //   if (this.plot.harvest.pictures && this.plot.harvest.pictures.length > 0) {
      //     return this.plot.harvest.pictures
      //   }
      // }

      return this.hasRelation('pictures');
    },

    comments() {
      return this.hasRelation('comments');
    },

    showPreEmergenceData() {
      return this.hasPreEmergence() && !this.editPreEmergence && this.activeStep === 0;
    },

    showEmergenceData() {
      return this.hasEmergence() && !this.editEmergence && this.activeStep === 1;
    },

    showHarvestData() {
      return this.hasHarvest() && !this.editHarvest && this.activeStep === 2;
    },

    showingData() {
      return (
        (this.activeStep === 0 && this.showPreEmergenceData) ||
        (this.activeStep === 1 && this.showEmergenceData) ||
        (this.activeStep === 2 && this.showHarvestData)
      );
    },
  },

  created() {
    const params = {
      include: [
        'preEmergence.pictures',
        'emergence.pictures',
        'harvest.pictures',
        'preEmergence.comments',
        'emergence.comments',
        'harvest.comments',
        'preEmergence.productionDestination',
      ],
    };

    this.plotId = +this.$route.params.id;

    this.$services
      .resource('plots')
      .show(this.plotId, params)
      .then((res) => res.data.data)
      .then((plot) => {
        this.plot = plot;
        this.isDataLoaded = true;
      });

    this.activeStep = this.currentStage;
  },

  methods: {
    updatePicture({ index, data }) {
      this.$services
        .resource('pictures')
        .update(this.pictures[index].id, data)
        .then(() => {
          this.pictures[index].description = data.description;
          this.$refs.imageList.resetEdition();
        });
    },

    removePicture(index) {
      const picture = this.pictures.splice(index, 1);
      this.$services.resource('pictures').delete(picture.pop().id);
    },

    hasRelation(relation) {
      if (this.plot.preEmergence && this.showPreEmergenceData) {
        if (this.plot.preEmergence[relation] && this.plot.preEmergence[relation].length > 0) {
          return this.plot.preEmergence[relation];
        }
      }

      if (this.plot.emergence && this.showEmergenceData) {
        if (this.plot.emergence[relation] && this.plot.emergence[relation].length > 0) {
          return this.plot.emergence[relation];
        }
      }

      if (this.plot.harvest && this.showHarvestData) {
        if (this.plot.harvest[relation] && this.plot.harvest[relation].length > 0) {
          return this.plot.harvest[relation];
        }
      }

      return false;
    },

    onChangeStep(prevIndex, nextIndex) {
      this.activeStep = nextIndex;
    },

    fetchPictures(id, resource, prop) {
      this.$services
        .resource(resource)
        .show(id, { include: 'pictures' })
        .then((res) => res.data.data)
        .then((data) => this.updatePlot(data.pictures, prop));
    },

    updatePlot(pictures, prop) {
      this.plot[prop].pictures = pictures;
    },

    hasPreEmergence() {
      return Boolean(this.plot) && Boolean(this.plot.preEmergence);
    },

    hasEmergence() {
      return Boolean(this.plot) && Boolean(this.plot.emergence);
    },

    hasHarvest() {
      return Boolean(this.plot) && Boolean(this.plot.harvest);
    },

    updatePreEmergence(preEmergence) {
      preEmergence.pictures = preEmergence.pictures || [];
      preEmergence.comments = preEmergence.comments || [];
      this.plot.preEmergence = preEmergence;
      this.editPreEmergence = false;
    },

    updateEmergence(emergence) {
      emergence.pictures = emergence.pictures || [];
      emergence.comments = emergence.comments || [];
      this.plot.emergence = emergence;
      this.editEmergence = false;
    },

    updateHarvest(harvest) {
      harvest.pictures = harvest.pictures || [];
      harvest.comments = harvest.comments || [];
      this.plot.harvest = harvest;
      this.editHarvest = false;
    },

    wizardComplete() {
      // we gather models from all steps into one model
      this.wizardModel = {};
      this.$router.push({ name: 'PlotShow', params: { id: this.plot.id } });
    },
  },
};
</script>

<style scoped>
::v-deep .trace-resume .plot-name {
  color: #2d2d2d !important;
}
</style>
